import { render, staticRenderFns } from "./OverdueForm.vue?vue&type=template&id=42262a31&"
import script from "./OverdueForm.vue?vue&type=script&lang=js&"
export * from "./OverdueForm.vue?vue&type=script&lang=js&"
import style0 from "./OverdueForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports